import React from 'react';
import PropTypes from 'prop-types';
import { StickyContainer } from 'sp-react-sticky';

import GlobalAlerts from './GlobalAlerts';

import NavigationBar, { HOMEPAGE_NAV_TYPE, INTERNAL_NAV_TYPE } from './NavigationBar';

export const TopnavContainer = ({ children, route: { navType } }) => (
  <main role="main">
    <NavigationBar navType={navType} />

    <StickyContainer className="main">
      { navType !== HOMEPAGE_NAV_TYPE && (
        <GlobalAlerts showBrowserSupportAlert={false} />
      ) }

      <div className="content">
        { children }
      </div>
    </StickyContainer>
  </main>
);

TopnavContainer.defaultProps = {
  route: {},
};

TopnavContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.element]),
  route: PropTypes.shape({
    navType: PropTypes.string,
  }).isRequired,
};

export { HOMEPAGE_NAV_TYPE, INTERNAL_NAV_TYPE };

export default TopnavContainer;



// WEBPACK FOOTER //
// ./src/components/TopnavContainer.js